// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2IjLI","list":"PatternAutocomplete_list__Yl5JE"};